;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	View.AccountUpdate = Marionette.ItemView.extend({
		tagName: 'div',
		ui: {
			'submitForm': '#js-account-update-submit',
			'deactivateAcc': '#js-deactivate-account',
			'tabContent': '#account',
			'stateInput': '.state',
			'update_response': '.update-response'
		},
		events: {
			'click @ui.submitForm': 'updateAccount',
			'click @ui.deactivateAcc': 'deactivateAccount',
			'submit @ui.updateAccountForm': 'updateAccount'
		},
		initialize: function() {
			this.user         = this.getOption('model');
			this.countries    = this.getOption('countries');
			this.states       = this.getOption('states');
			this.squads       = this.getOption('squads');
			this.fields       = this.getOption('fields');
			this.is_au        = this.user.country == 'AU';
			this.formTemplate = this.getOption('template');

			var fields = this.fields;
			fields = fields.split(',');
			this.fields = fields;
			fields = _.map(fields , function(field){
				return field+':blur ' + field+':change';
			});

			var template = JST[this.formTemplate+'accountUpdate'];
			template =  _.isFunction(template) ? template :  JST.accountUpdate;

			
			this.form = new Backbone.Form({
				template: template,
				templateData: {
					fields: this.fields
				},
				model: this.user
			});

			this.listenTo(this.form, fields.join(' '), this.changeAndBlur);
			this.listenTo(this.form, 'country:change' , this.changeCountry);
			this.errors     = false;

			this.showPreloader();
			
			var collections = [this.squads, this.countries, this.states],
				complete = _.invoke(collections, 'fetch', {cache: true, expires: 60 });
			this.user.getProfile();
			$.when.apply(null, complete).done(_.bind(function() {
				
				this.setTemplateData();

			}, this));


			this.customInitAdder();

		},
		render: function () {
			this.$el.html(this.form.$el);
			this.changeCountry(this.form,_.first(this.form.fieldsets).fields.country);
			this.showCurrentTab();
			return this;
		},

		customInitAdder: function(){
			this.listenTo(this.form, 'change' , this.clearAll);
			return this;
		},
		changeCountry: function(model, item){
			var toggleParents = (_.bind(function(model, item){
				var $state_input = $(this.ui.stateInput),
					$parents     = $state_input.parents().eq(2),
					is_val       = item && item.getValue() == 'AU',
					show_or_hide = is_val ? 'show' : 'hide',
					new_val      = is_val ? this.user.get('state') : '';

				$parents[show_or_hide]();
;
				$state_input.val(new_val);

			}, this, model, item));
			setTimeout(toggleParents, 0);
		},
		changeAndBlur: function(form, editor){
			var errs        = this.form.fields[editor.key].validate(),
				$el         = $(editor.el),
				is_no_error = !errs && editor.previousValue;

			this.errors = errs && editor.previousValue;

			is_no_error ? $el.addClass('valid') : $el.removeClass('valid');

			return this;
		},

		updateAccount: function(event) {
			event.preventDefault();

			if($(this.ui.submitForm).hasClass('success-update')){
				return;
			}

			var err = this.form.validate();

			this.showPreloader();

			this.errors = false;

			_.find(this.fields, _.bind(function(value){
				if(_.has(err, value)){
					this.scrollToFieldError(err, value);
					return this.errors = true;
				}
			},this));

			console.log(this.errors);
			if (this.errors){
				return this.hidePreloader();
			}

			//console.log(this.form.getValue());

			var
				form_values_fields = this.form.getValue(),
				form_values = _.omit(form_values_fields, (value, key) => {
					const user = this.user.attributes;
					// console.log(this.user);
					if (key === 'avatar') {
						return false;
					}

					return _.isUndefined(value) || _.isNull(value)|| +value === 0 || value === user[key];
				}),
				user_updated_data = this.getUserObject(form_values)
			;

			this.updateUser(user_updated_data);

			$.when.call(null, this.user.update(user_updated_data)).done(_.bind(function(response){
				if (response.errors.length) {
					this.showErrors(response.errors);
				}
				else {
					var updated_data = _.extend(this.user.toJSON(), response.result.user);

					this.user.set(updated_data);

					APP.vent.trigger('user:get:profile', updated_data);
					this.successUpdateFinish();

				}

				this.hidePreloader();

			}, this));

			return this;
		},
		getUserObject: function(form) {
			return _.pick(form, this.fields);
		},

		updateUser: function(updated_data){

			this.user.set(updated_data);

			return this;

		},

		setTemplateData: function(){

			this.form.data = {
				countryList: this.countries,
				statesList: this.states,
				squads: this.squads.toJSON()
			};

			this.form.render();
			this.render();

			this.changeCountry(this.form,_.first(this.form.fieldsets).fields.country);

			this.hidePreloader();

			return this;

		},
		showCurrentTab: function(){
			var _this = this;

			setTimeout(function(){
				$(_this.ui.tabContent).find('.panel-body').addClass('open-tab');
			}, 10);
		},
		deactivateAccount:function(){
			this.showPreloader();

			if(confirm("Are you sure that you want to deactivate your account?" )){
				this.user.deactivate();
			}

			this.hidePreloader();

			return this;
		},
		scrollToFieldError: function(err, val){
			$('html, body').animate({
				scrollTop: $(this.form.fields[val].el).offset().top
			}, 500);
		},
		successUpdateFinish: function(){
			$(this.ui.update_response).html('Thank you, your account has been updated');
			$(this.ui.submitForm).addClass('success-update').html('Updated');

			return this;
		},
		clearAll: function(){
			$(this.ui.update_response).html('');
			$(this.ui.submitForm).removeClass('success-update').html('Update');

			return this;
		},
		getProfile: function(user){
			return this.setApiUrl( 'user/show_my_profile' ).save(null, {
				type: 'GET',
				ajaxSync: true,
				data: false,
				success: _.bind(function(model, response){
					var updated_data = _.extend(model.toJSON(), response.result);
					this.set(updated_data);
				}, this)
			}, this);
		},
	});

}(window, APP, Backbone, Marionette, $, _));